import React from 'react'
import { Helmet } from 'react-helmet'
import LiveTemplateDefault from 'src/components/template/live'
import { networkLogos } from 'src/constants'
import { createVideoStructuredData } from 'src/modules/utils/videoStructuredData'

export default (props) => {
  const videoStructuredData = createVideoStructuredData({
    networkName: 'CBS',
    callsign: 'CBS',
    logoUrl: networkLogos.cbs.logoUrl,
    slug: 'cbs',
  })

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(videoStructuredData)}</script>
      </Helmet>
      <LiveTemplateDefault
        location={props.location}
        lang="en"
        market="us"
        callsign="CBS"
        title="Watch CBS live with Fubo"
        networkName="CBS"
        showRedzone={false}
      />
    </>
  )
}
